module.exports = __webpack_public_path__ + "img/safe.07b1a13e.svg";